export default "__VITE_ASSET__DzTN0lVW__"